// @ts-check

import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import _module from '@/store/base/module'

const module = {
  state: {
    project: {
      crowdFundQuote: {
        type: 'quote',
        title: '众筹',
        desc: '「众筹」是实现梦想、支持创新和共同努力的方式。 通过众筹，我们可以一起创造未来。',
        author: 'Jane Chang, 创业家'
      },
      newCrowdFund: {
        type: 'carousel',
        title: '最新众筹项目',
        subtitle: '发掘最新众筹机会，支持创新创意',
        input: {
          filter: { sort_by: 'newest', intention: ['crowdFunding'], project_status: 'PUBLISHED' },
          pagination: { current_page: 1, per_page: 9 }
        },
        items: []
      },
      popularCrowdFund: {
        type: 'carousel',
        title: '热门众筹项目',
        subtitle: '探索最受欢迎的众筹项目，参与热潮',
        input: {
          filter: { sort_by: 'most_popular', intention: ['crowdFunding'], project_status: 'PUBLISHED' },
          pagination: { current_page: 1, per_page: 9 }
        },
        items: []
      },
      investQuote: {
        type: 'quote',
        title: '投资',
        desc: '「投资」是实现财务增长、实现财务目标的方式。 通过投资，我们可以一起创造财富。',
        author: 'Jhon Doe, 创业家'
      },
      newInvest: {
        type: 'carousel',
        title: '最新投资机会',
        subtitle: '把握最新的投资机遇，实现财务增长',
        input: {
          filter: { sort_by: 'newest', intention: ['investment'], project_status: 'PUBLISHED' },
          pagination: { current_page: 1, per_page: 9 }
        },
        items: []
      },
      popularInvest: {
        type: 'carousel',
        title: '热门投资机会',
        subtitle: '发现备受瞩目的投资项目，实现财富增值',
        input: {
          filter: { sort_by: 'most_popular', intention: ['investment'], project_status: 'PUBLISHED' },
          pagination: { current_page: 1, per_page: 9 }
        },
        items: []
      },
      seekingPartnersQuote: {
        type: 'quote',
        title: '寻找合作伙伴',
        desc: '「寻找合作伙伴」是为了一起追求更大的目标和创造更多机会。合作让我们一同前行。',
        author: 'Grace Liu, 创业者'
      },
      newPartner: {
        type: 'carousel',
        title: '最新合作伙伴机会',
        subtitle: '把握最新的合作伙伴机遇，一同追求更大的目标',
        input: {
          filter: { sort_by: 'newest', intention: ['seekingPartners'], project_status: 'PUBLISHED' },
          pagination: { current_page: 1, per_page: 9 }
        },
        items: []
      },
      popularPartner: {
        type: 'carousel',
        title: '热门合作伙伴机会',
        subtitle: '发现备受瞩目的合作伙伴项目，共同创造更多机会',
        input: {
          filter: { sort_by: 'most_popular', intention: ['seekingPartners'], project_status: 'PUBLISHED' },
          pagination: { current_page: 1, per_page: 9 }
        },
        items: []
      }
    }
  },

  getters: {
    getProject: state => {
      return state.project
    }
  },

  mutations: {
  },

  actions: {
    init: ({ state }) => {
      const inputData = {}
      for (const key in state.project) {
        if (!state.project[key].input) continue
        inputData[key] = {
          api: 'C0101ProjectService.homeSearch',
          input: state.project[key].input
        }
      }
      return ApiUtils.postData({
        data: inputData
      }).then(data => {
        for (const key in data) {
          state.project[key].items = data[key].output.data
        }
      })
    }
  }
}

export default ObjArrUtils.merge(_module, module)
